<template>
  <div class="writtenGrade" :class="{ 'isProp': testPlanId }">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="考场名称" v-if="!testPlanId">
          <el-input v-model="filter.title" placeholder="请输入考场名称"></el-input>
        </el-form-item>
        <el-form-item label="考试项目" v-if="!testPlanId">
          <el-input v-model="filter.testProject" placeholder="请输入考试项目"></el-input>
        </el-form-item>
        <el-form-item label="班级名称" v-if="!testPlanId">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="综合评定成绩" v-if="!testPlanId">
          <el-select v-model="filter.evaluationAll" placeholder="请选择综合评定成绩" clearable>
            <el-option label="合格" value="合格"></el-option>
            <el-option label="不合格" value="不合格"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="filter.contractSignName" placeholder="请输入学员姓名"></el-input>
        </el-form-item>
        <el-form-item v-if="!testPlanId" label="代理商名称">
          <el-input v-model="filter.agentName" placeholder="请输入代理商名称"></el-input>
        </el-form-item>
        <el-form-item v-if="!testPlanId" label="分销商名称">
          <el-input v-model="filter.distributName" placeholder="请输入分销商名称"></el-input>
        </el-form-item>
        <el-form-item label="专业岗位名称" v-if="!testPlanId">
          <el-input v-model="filter.professionalPosition" placeholder="请输入专业岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号" v-if="testPlanId">
          <el-input v-model="filter.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="证件号码" v-if="testPlanId">
          <el-input v-model="filter.contractSignIdCard" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table :data="list" border>
        <el-table-column key="1" v-if="!testPlanId" align="center" label="考场名称" prop="title" width=""></el-table-column>
        <el-table-column key="2" v-if="!testPlanId" align="center" label="班级名称" prop="skuName" width=""></el-table-column>
        <el-table-column key="3" v-if="!testPlanId" align="center" label="考试项目" prop="testProject" width=""></el-table-column>
        <el-table-column key="4" v-if="!testPlanId" align="center" label="学员姓名" prop="contractSignName" width=""></el-table-column>
        <el-table-column key="21" v-if="!testPlanId" align="center" label="代理商名称" prop="agentName" minWidth="120"></el-table-column>
        <el-table-column key="22" v-if="!testPlanId" align="center" label="分销商名称" prop="distributName" minWidth="120"></el-table-column>
        <el-table-column key="5" v-if="!testPlanId" align="center" label="考试状态" prop="testStatus" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.testStatus === 9">正常</span>
            <span v-if="scope.row.testStatus === 11">舞弊</span>
            <span v-if="scope.row.testStatus === 12">缺考</span>
          </template>
        </el-table-column>
        <el-table-column key="6" v-if="!testPlanId" align="center" label="身份证号" prop="contractSignIdCard" width=""></el-table-column>
        <el-table-column key="7" v-if="!testPlanId" align="center" label="专业岗位名称" prop="professionalPosition" width=""></el-table-column>
        <el-table-column key="8" v-if="!testPlanId" align="center" label="操作技能成绩" prop="operation" width=""></el-table-column>
        <el-table-column key="9" v-if="!testPlanId" align="center" label="理论知识技能" prop="theory" width=""></el-table-column>
        <el-table-column key="10" v-if="!testPlanId" align="center" label="综合评定成绩" prop="evaluationAll" width=""></el-table-column>

        <!-- 弹窗数据  -->
        <el-table-column key="11" v-if="testPlanId" align="center" label="学员姓名" prop="contractSignName" width=""></el-table-column>
        <el-table-column key="23" v-if="testPlanId" align="center" label="代理商名称" prop="agentName" minWidth="120"></el-table-column>
        <el-table-column key="24" v-if="testPlanId" align="center" label="分销商名称" prop="distributName" minWidth="120"></el-table-column>
        <el-table-column key="12" v-if="testPlanId" align="center" label="证件类型" prop="contractSignType" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.contractSignType == 1">身份证</span>
            <span v-if="scope.row.contractSignType == 2">护照</span>
            <span v-if="scope.row.contractSignType == 3">军官证</span>
            <span v-if="scope.row.contractSignType == 4">港澳台通行证</span>
          </template>
        </el-table-column>
        <el-table-column key="13" v-if="testPlanId" align="center" label="证件号码" prop="contractSignIdCard" minWidth="170"></el-table-column>
        <el-table-column key="14" v-if="testPlanId" align="center" label="手机号" prop="phone" minWidth="150"></el-table-column>
        <el-table-column key="15" v-if="testPlanId" align="center" label="报名时间" prop="insertDate" minWidth="160"></el-table-column>
        <el-table-column key="16" v-if="testPlanId" align="center" label="学员考试时间" prop="testFrom" minWidth="160"></el-table-column>
        <el-table-column key="17" v-if="testPlanId" align="center" label="考试状态" prop="testStatus" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.testStatus === 9">正常</span>
            <span v-if="scope.row.testStatus === 11">舞弊</span>
            <span v-if="scope.row.testStatus === 12">缺考</span>
          </template>
        </el-table-column>
        <el-table-column key="18" v-if="testPlanId" align="center" label="操作技能成绩" prop="operation" minWidth="120"></el-table-column>
        <el-table-column key="19" v-if="testPlanId" align="center" label="理论知识技能" prop="theory" minWidth="120"></el-table-column>
        <el-table-column key="20" v-if="testPlanId" align="center" label="综合评定成绩" prop="evaluationAll" minWidth="120"></el-table-column>
        <el-table-column key="999" align="center" label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <a v-if="scope.row.isCancel === 1" href="javascript:;" @click="toCancle(scope.row)">取消报名</a>&emsp;
            <a href="javascript:;" v-if="scope.row.imgUrl" @click="lookPic(scope.row)">查看证件照片</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-image-viewer v-if="isShow" :on-close="closeImgViewer" :url-list="[imgUrl]"></el-image-viewer>
    <!-- 查看学员-查看证件照片 -->
    <el-dialog
      title="查看证件照片"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :before-close="handleClose">
      <el-form :model="picForm" size="small" label-width="120px">
        <el-form-item label="证件照片：">
          <PictureUpload v-model="picForm.imgUrl" :maxSize="1" />
          <p class="form-tips">支持扩展名: .png .jpeg .jpg 文件大小1M以内</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmitPicForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import FileExport from "@/components/FileExport.vue";
import PictureUpload from "@/components/pictureUpload.vue"
import { getUserList, userTestPlanDel, handleUpdateImg } from '@/api/product/testPlanItem'
import dayjs from 'dayjs';

export default {
  name: 'WrittenGrade',
  props: {
    testPlanId: {
      type: [String, Number],
      default: ''
    }
  },
  components:{
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    FileExport,
    PictureUpload
  },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        title: '',
        testProject: '',
        skuName: '',
        evaluationAll: '',
        evaluationAll: '',
        contractSignName: '',
        agentName: '',
        distributName: '',
        professionalPosition: '',
        phone: '',
        contractSignIdCard: ''
      },
      list: [],
      total: 0,
      isShow: false,
      imgUrl: '',
      dialogVisible: false,
      picForm: {
        userId: '',
        imgUrl: []
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getUserList({...this.filter, testPlanId: this.testPlanId})
      this.list = res.data.records
      this.total = +res.data.total
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    // 导出
    handleExport () {
      const params = {
        ...this.filter,
        testPlanId: this.testPlanId
      }
      delete params.page
      delete params.limit
      this.$refs.FileExport.init(
        params, // 搜索表单参数
        "jsw-product-provider", // 后端对应业务线服务
        "/adm/userTestPlan/export", // 导出-对应的接口
        1, //  状态：0get、1post
        "学员列表.xlsx" //文件名称
      );
    },
    toCancle(row) {
      if (dayjs().isAfter(dayjs(row.testFrom).subtract(1, 'day'))) {
        this.$message.warning('考场开始时间前一天内不可以取消报名!')
        return
      }
      this.$confirm(`确认取消用户${row.contractSignName}的报名?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await userTestPlanDel({id: row.id})
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      }).catch(() => {})
    },
    lookPic(row) {
      if (this.testPlanId) {
        this.picForm.userId = row.userId
        this.picForm.imgUrl = row.imgUrl ? [{ url: row.imgUrl }] : []
        this.dialogVisible = true
        return
      }
      this.imgUrl = row.imgUrl
      this.isShow = true
    },
    closeImgViewer() {
      this.isShow = false
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleSubmitPicForm() {
      if (this.picForm.imgUrl.length === 0) {
        this.$message.warning('请上传证件照片!')
        return
      }
      const params = {
        ...this.picForm,
        imgUrl: this.picForm.imgUrl[0].url
      }
      handleUpdateImg(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('保存成功!')
          this.getList()
          this.handleClose()
        }
      })
    },
    handleClose() {
      this.picForm = this.$options.data().picForm
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.isProp {
  .el-card {
    box-shadow: none;
    background: none;
    border: none;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
}
</style>
